// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/benefits-in-kind",
  ListShort: "pyr/benefits-in-kind/short",
  Create: "/pyr/benefits-in-kind",
  Update: "/pyr/benefits-in-kind",
};
